module.exports = __webpack_public_path__ + "img/bg.e54a48c0.svg";